"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _OzCheck = _interopRequireDefault(require("./../OzCheck/OzCheck.js"));

var _consts = require("./../consts.js");

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzCheckbox__Wrapper",
  componentId: "sc-1oogjym-0"
})(["\n  text-align: left;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"]);

var Row = _styledComponents.default.div.withConfig({
  displayName: "OzCheckbox__Row",
  componentId: "sc-1oogjym-1"
})(["\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  height: 34px;\n  border\n"]);

var FakeLabel = _styledComponents.default.div.withConfig({
  displayName: "OzCheckbox__FakeLabel",
  componentId: "sc-1oogjym-2"
})(["\n  margin-top: 20px;\n  margin-bottom: 5px;\n  font-size: 11px;\n  font-weight: 300;\n"]);

var Label = _styledComponents.default.div.withConfig({
  displayName: "OzCheckbox__Label",
  componentId: "sc-1oogjym-3"
})(["\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: 8px;\n"]);

var Description = _styledComponents.default.div.withConfig({
  displayName: "OzCheckbox__Description",
  componentId: "sc-1oogjym-4"
})(["\n  font-size: 11px;\n  font-weight: 400;\n  color: ", ";\n  // margin-left: 28px;\n"], _consts.SPANISHGREY);

var OzCheckbox = function OzCheckbox(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "default" : _ref$variant,
      label = _ref.label,
      description = _ref.description,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      _onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required;
  return __jsx(Wrapper, null, __jsx(FakeLabel, null, "\xA0"), __jsx(Row, null, __jsx(_OzCheck.default, {
    variant: variant,
    disabled: disabled,
    selected: selected,
    onChange: function onChange() {
      if (!disabled) {
        if (_onChange) {
          _onChange(!selected);
        }
      }
    }
  }), label ? __jsx(Label, null, label, " ", required ? "*" : "") : null), description ? __jsx(Description, null, description) : null);
};

var _default = OzCheckbox;
exports.default = _default;